import { observer, Provider } from 'mobx-react';
import Main from './Main';
import Store from './store';

function RoleFrom(props: any) {
  const store = new Store({ refreshToken: props.refreshToken });

  return (
    <Provider store={store}>
      <div id="microauth-authentication" className="w-full h-full">
        <Main {...props} />
      </div>
    </Provider>
  );
}

export default observer(RoleFrom);
